import API from './index';

const api = {
    getApplicationDocByParams({ params }) {
        return API.authAPI({
            url: '/arrangement-meeting/get-application-doc-byParams',
            method: 'GET',
            params: { ...params },
        });
    },
    getMeetingArrangementMemberList({ params }) {
        return API.authAPI({
            url: '/meeting-arrangement-member/list',
            method: 'GET',
            params: { ...params },
        });
    },
    addMeetingArrangementForm({ data }) {
        return API.authAPI({
            url: '/arrangement-meeting/add-meeting-arrangement-form',
            method: 'POST',
            data,
        });
    },
    editMeetingArrangementForm({ data }) {
        return API.authAPI({
            url: '/arrangement-meeting/update-meeting-arrangement-form',
            method: 'POST',
            data,
        });
    },
    getMeetingArrangeList(params) {
        return API.authAPI({
            url: '/arrangement-meeting/get-meeting-arrangement-form-byParams',
            method: 'GET',
            params: { ...params },
        });
    },
    getMeetingArrangementFormDetail(params) {
        return API.authAPI({
            url: '/arrangement-meeting/get-meeting-arrangement-form-detail',
            method: 'GET',
            params: { ...params },
        });
    },
};

export default api;
